import { useNavigate } from "react-router-dom";
import TopicButton from "../components/TopicButton";

function Home() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Welcome Section */}
      <div className="py-8 px-4 sm:py-12 sm:px-6">
        <div className="max-w-6xl mx-auto">
          {/* Title and Subtitle */}
          <div className="text-center mb-8 sm:mb-12">
            <h1 className="text-3xl sm:text-4xl font-bold mb-2 sm:mb-3">
              Welcome to Kuzko History!
            </h1>
            <p className="text-base sm:text-lg text-gray-700 px-4">
              How would you like to find a history lesson today?
            </p>
          </div>

          {/* Interactive Cards */}
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-6 sm:space-y-0 sm:space-x-8 lg:space-x-16 mb-8 sm:mb-12">
            {/* Filter by Topic Card */}
            <TopicButton
              text="Filter by Topic"
              onClick={() => navigate("/topics")}
            />

            {/* See all Lessons Card */}
            <TopicButton
              text="See all Lessons"
              onClick={() => navigate("/lessons")}
            />

            {/* See all Videos Card */}
            <TopicButton
              text="See all Videos"
              onClick={() => navigate("/videos")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
